export default "__VITE_ASSET__DYJ4f2tJ__"